import Model from '@/models/Model'

export default class PosCustomerReceivablePayment extends Model {

  /**
   * { item_description }
   */
  static appends = [
    'transformed_payments'
  ]

  /**
   * { item_description }
   */
  static includes = [
    'g_user.hr_employee',
    'pos_cash_desk.g_branch_office',
    'pos_detail_customer_receivable_payments',
    'sl_customer',
  ]

  /**
   * { property_description }
   * @type       {<type>}
   */
  get sl_customer_business_name() {
    return this.getProperty('sl_customer.business_name', '-')
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get sl_customer_branch_offices_addresses() {
    return this.getProperty('pos_detail_customer_receivable_payments', []).map(this.mapReceivableAddress)
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get sl_customer_branch_offices_addresses_unique() {
    return [ ...new Set(this.sl_customer_branch_offices_addresses) ]
  }

  /**
   * { function_description }
   * @return     {<type>}  { description_of_the_return_value }
   */
  mapReceivableAddress = (item) => {
    return this.getPropertyFrom('sl_customer_receivable.sl_customer_branch_offices.address', '-', item)
  }

  /**
   * { function_description }
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'pos_customer_receivable_payment'
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get realPayDate() {
    try {
      if (this.pos_detail_customer_receivable_payments)
          return this.pos_detail_customer_receivable_payments[0]
              .created_at
    } catch (e) {
      return `e: ${e}`
    }
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get paidAmount() {
    try {
      if (this.pos_detail_customer_receivable_payments)
          return this.pos_detail_customer_receivable_payments[0].amount
    } catch (e) {
      return `e: ${e}`
    }
  }

  /**
   * { property_description }
   * @type       {<type>}
   */
  get paymentMathod() {
    try {
      if (this.transformed_payments)
          return this.transformed_payments[0].type
    } catch (e) {
      return `e: ${e}`
    }
  }
}
